// © Microsoft Corporation. All rights reserved.

/**
 * An enumeration containing key performance metric suffixes
 */
export enum KeyMetricTags {
    searchBox = "SearchBox",
    riverFirstSection = "RiverFirstSection",
    desktopFeedStart = "DesktopFeedStart",
    wpoCallStart = "WpoCallStart",
    wpoResponseBack = "WpoResponseBack",
    firstSectionRenderStart = "FirstSectionRenderStart",
    secondSectionRenderStart = "SecondSectionRenderStart"
}
